import React, { useState, useEffect } from "react";
import axios from "axios";
import { Notyf } from 'notyf';
import Swal from 'sweetalert2'
import { useNavigate } from "react-router-dom";
import exportValue from "../apiconfig";
import Left_panel from './Left_panel';
import Sub_header from './Sub_header';
import EChartsReact from "echarts-for-react";
import { useTheme } from '@material-ui/core/styles';
import {useSelector, useDispatch } from "react-redux";
import { DashboardLists } from "../redux/actions/DashboardActions";
import {CanvasJSChart} from 'canvasjs-react-charts'
const Index = () => {
    const { palette } = useTheme()
    let navigate = useNavigate();
    const loginDetail = localStorage.getItem('admin_login');  
    console.log("e => ", loginDetail);
    if(loginDetail == null) {
        console.log(" not valid ");
       // window.location.href = '/login';
        //navigate('/login',{ replace: true })
    }
    const notyf = new Notyf();
    
    const [state, setState] = useState({admin:[{total_amount:""}],users_find_count:"", count_vehicle_lists:"", count_transporterList: "", count_shipment: "",count_shipment_bids:"",count_spamReport:"",mon_shipment:"",tue_shipment:"",wed_shipment:"",thu_shipment:"",fri_shipment:"",sat_shipment:"",sun_shipment:"",mon_users:"",tue_users:"",wed_users:"",thu_users:"",fri_users:"",sat_users:"",sun_users:"",mon_payments:"",tue_payments:"",wed_payments:"",thu_payments:"",fri_payments:"",sat_payments:"",sun_payments:"",week_amount:""});
    const [states,setStates] = useState({isLoading:true});
  const[dimensionState,setdimensionState] = useState({companyDetail:[]})

  const dispatch = useDispatch();
    useEffect(() => {
        dispatch(DashboardLists())
    }, [])
   // dashboardData
    const getDashboardCount = useSelector((state)=> state.dashboardData.dashboardTotalCount)
  
    console.log("one",getDashboardCount);
    if(getDashboardCount && states.isLoading == true){
         setStates({isLoading:false})
        setState(getDashboardCount)
    }

    // const GetDays = (d,Mention_today=false)=>{
    //     //Mention today mean the array will have today date 
    //     var DateArray = [];
    //     var days=d;
    //     for(var i=0;i<days;i++){
    //     if(!Mention_today && i==0){i=1;days+=1}
    //     var date = new Date();
    //     var last = new Date(date.getTime() - (i * 24 * 60 * 60 * 1000));
    //     var day =last.getDate();
    //     var month=last.getMonth()+1;
    //     var year=last.getFullYear();
    //     const fulld = (Number(day)) // Format date as you like
    //     DateArray.push(fulld);
    //     }
    //     return DateArray;
    //     }
    //    console.log(GetDays(5)) //Will get the past 5 days formated YY-mm-dd
      
    const dimension_detail = () =>{
        let full_api = exportValue.host + '/' + exportValue.version + '/' + exportValue.api + `/company_info_api`;
        let sendData = {};
      
        axios.post(full_api, sendData, { headers: exportValue.headers }).then(res => {
          setdimensionState({...dimensionState,companyDetail:res.data.companyDetail});
          console.log("rnmmmmm", res);
        }).catch((e) => {
          // toast.configure()
           //toast.error("Some thing went wrong")
          console.log("----error:   ", e);
        })
      }
      React.useEffect(() => {
       // dimension_detail();
      
       
       
      }, [])
      

   


function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height
    };
}
function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
}
const option = {
    grid: {
        left: '6%',
        bottom: '10%',
        right: '1%',
    },
    legend: {
        itemGap: 20,
        icon: 'circle',
        textStyle: {
            color: palette.text.secondary,
            fontSize: 13,
            fontFamily: 'Nunito',
        },
    },
    color: [
       '#050505',
        '#f0b87d'
       
    ],
    barMaxWidth: '10px',
    tooltip: {},
    dataset: {
        source: [
            ['Days','',''],
            ['Mon',state.mon_shipment,state.mon_users],
            ['Tue',state.tue_shipment,state.tue_users],
            ['Wed',state.wed_shipment,state.wed_users],
            ['Thu',state.thu_shipment,state.thu_users],
            ['Fri',state.fri_shipment,state.fri_users],
            ['Sat',state.sat_shipment,state.sat_users],
            ['Sun',state.sun_shipment,state.sun_users],
           


        ],
    },
    xAxis: {
        type: 'category',
        axisLine: {
            show: false,
        },
        splitLine: {
            show: false,
        },
        axisTick: {
            show: false,
        },
        axisLabel: {
            color: '#050505',
            fontSize: 13,
            justifyContent: 'space-between',
            
            fontFamily: 'Nunito',
        },
    },
    yAxis: {
        axisLine: {
            show: false,
        },
        axisTick: {
            show: false,
        },
        splitLine: {
            // show: false
            lineStyle: {
                color: palette.text.secondary,
                opacity: 0.15,
            },
        },
        axisLabel: {
            color: palette.text.secondary,
            fontSize: 8,
            fontFamily: 'Nunito',
        },
    },
    // Declare several bar series, each will be mapped
    // to a column of dataset.source by default.
    series: [
       
        {
            type: 'bar',
            itemStyle: {
                barBorderRadius: [10, 10, 0, 0],
            },
        },
        {
            type: 'bar',
            itemStyle: {
                barBorderRadius: [10, 10, 0, 0],
            },
        },
    ],
}
const option1 = {
   
        xAxis: {
          type: "category",
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
        },
        color: [
            
             '#f0b87d'
            
         ],
        yAxis: {},
        series: [
       
            {
                type: 'line',
                data: [state.mon_payments, state.tue_payments, state.wed_payments, state.thu_payments, state.fri_payments, state.sat_payments, state.sun_payments],
            },
           
        ],
      }





const { height, width } = useWindowDimensions();
const leftpanel =()=>{
    console.log("onclick");
    <Left_panel/>
}
  return (
    <div>
        
      

       
        <Sub_header/>
<div style={{marginLeft:"15px",marginRight:"15px"}}>        
    <section class="pt-5">
        <div class="row">
            <div class="col-12  col-sm-6 col-xl-4 mb-4">
                <div class="card border-0 shadow">
                    <div class="card-body">
                        <div class="row d-block d-xl-flex align-items-center">
                            <div class="col-6 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                                <div class="icon-shape icon-shape-success rounded me-4 me-sm-0">
                                    <i class="fa fa-cube fa-2x" aria-hidden="true"></i>
                                </div>
                            </div>
                            
                            <div class="col-6 col-xl-7 px-xl-0">
                            <a href="/shipments">
                                <div class="d-sm-block">
                                    <h2 class="h6 text-gray-400 mb-0">Shipments</h2>
                                    <h3 class="fw-extrabold mb-2">{state.count_shipment}</h3>
                                </div>
                                </a>
                                <small class="d-flex align-items-center text-gray-500">
                                    {/* Last 3 months */}
                                </small> 
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-xl-4 mb-4">
                <div class="card border-0 shadow">
                    <div class="card-body">
                        <div class="row d-block d-xl-flex align-items-center">
                            <div class="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                                <div class="icon-shape icon-shape-secondary rounded me-4 me-sm-0">
                                    <i class="fa fa-2x fa-users" aria-hidden="true"></i>
                                </div>
                            </div>
                            <div class="col-12 col-xl-7 px-xl-0">
                            <a href="/users">
                                <div class=" d-sm-block">
                                    <h2 class="h6 text-gray-400 mb-0">Users</h2>
                                    <h3 class="fw-extrabold mb-2">{state.users_find_count}</h3>
                                </div>
                                </a>
                                <small class="d-flex align-items-center text-gray-500">
                                    {/* Last 3 months */}
                                </small> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-xl-4 mb-4">
                <div class="card border-0 shadow">
                    <div class="card-body">
                        <div class="row d-block d-xl-flex align-items-center">
                            <div class="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                                <div class="icon-shape icon-shape-info rounded me-4 me-sm-0">
                                    <i class="fa fa-2x fa-credit-card" aria-hidden="true"></i>
                                </div>
                            </div>
                            <div class="col-12 col-xl-7 px-xl-0">
                            <a href="/payments">
                                <div class=" d-sm-block">
                                    <h2 class="h6 text-gray-400 mb-0"> Payments</h2>
                                   <h3 class="fw-extrabold mb-2"> {dimensionState.companyDetail.map((sub)=>(
                                    sub.set_currency
                                   ))}{state.admin[0].total_amount}</h3>
                                </div>
                                </a>
                                <small class="text-gray-500">
                                  {/* Last 3 months */}
                                </small> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section>
            <div class="row">
                <div class="col-8 mb-4">
                    <div class="card bg-yellow-100 border-0 shadow">
                        <div class="card-header d-sm-flex flex-row align-items-center flex-0">
                            <div class="d-block mb-3 mb-sm-0">
                                <div class="fs-5 fw-normal mb-2">Payments </div>
                                <div class="small mt-2"> 
                                    {/* <span class="fw-normal me-2">Last three months</span>                                     */}
                                    {/* <span class="text-success fw-bold">10.57%</span> */}
                                </div>
                            </div>
                            <div class="d-flex ms-auto">
                                <h2 class="fs-3 fw-extrabold">{dimensionState.companyDetail.map((sub)=>(
                                    sub.set_currency
                                   ))}{state.week_amount} <small>(per week)</small></h2>
                            </div>
                        </div>
                        <div class="card-body p-2">
                       
                        <EChartsReact option = {option1} />
                        <small style={{marginLeft:"290px"}} >(per day)</small>
                            {/* <div class="ct-chart-sales-value ct-double-octave ct-series-g"></div> */}
                        </div>
                    </div>
                </div>
                <div class="col mb-4">
                    <div class="card border-0 shadow">
                        <div class="card-header custom_heade d-flex flex-row align-items-center flex-0 border-bottom">
                            <div class="d-block">
                                <div class="h6 fw-normal text-gray mb-2">Summary <small>(per Day)</small></div>
                            </div>
                            <div class="d-block ms-auto">
                                <div class="d-flex align-items-center text-end mb-2">
                                    <span class="dot rounded-circle bg-gray-800 me-2"></span>
                                    <span class="fw-normal small">Shipments</span> &nbsp;
                                    <span class="dot rounded-circle bg-secondary me-2"></span>
                                    <span class="fw-normal small">Users</span>
                                </div>
                            </div>
                        </div>
                    <EChartsReact style={{ height: 340 }} option={option} />
                        {/* <div class="card-body p-2">
                            <div class="ct-chart-ranking ct-golden-section ct-series-a"></div>
                        </div> */}
                    </div>
                </div>
            </div>

            <section class="pt-1">
                <div class="row">
                    <div class="col-12 col-sm-6 col-xl-4 mb-4">
                        <div class="card border-0 shadow">
                            <div class="card-body">
                                <div class="row d-block d-xl-flex align-items-center">
                                    <div class="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                                        <div class="icon-shape icon-shape-primary rounded me-4 me-sm-0">
                                            <i class="fa fa-truck fa-2x" aria-hidden="true"></i>
                                        </div>
                                    </div>
                                    <div class="col-12 col-xl-7 px-xl-0">
                                    <a href="/transporters">
                                        <div class="d-sm-block">
                                            <h2 class="h6 text-gray-400 mb-0">Transporters</h2>
                                            <h3 class="fw-extrabold mb-2">{state.count_transporterList}</h3>
                                        </div>
                                        </a>
                                        <small class="d-flex align-items-center text-gray-500">
                                            {/* Last 3 months */}
                                        </small> 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-xl-4 mb-4">
                        <div class="card border-0 shadow">
                            <div class="card-body">
                                <div class="row d-block d-xl-flex align-items-center">
                                    <div class="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                                        <div class="icon-shape icon-shape-danger rounded me-4 me-sm-0">
                                            <i class="fa fa-2x fa-gavel" aria-hidden="true"></i>
                                        </div>
                                    </div>
                                    <div class="col-12 col-xl-7 px-xl-0">
                                        <div class=" d-sm-block">
                                            <h2 class="h6 text-gray-400 mb-0">Bids</h2>
                                            <h3 class="fw-extrabold mb-2">{state.count_shipment_bids}</h3>
                                        </div>
                                        <small class="d-flex align-items-center text-gray-500">
                                            {/* Last 3 months */}
                                        </small> 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-xl-4 mb-4">
                        <div class="card border-0 shadow">
                            <div class="card-body">
                                <div class="row d-block d-xl-flex align-items-center">
                                    <div class="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                                        <div class="icon-shape icon-shape-info rounded me-4 me-sm-0">
                                            <i class="fa fa-2x fa-exclamation-triangle" aria-hidden="true"></i>
                                        </div>
                                    </div>
                                    <div class="col-12 col-xl-7 px-xl-0">
                                    <a href="/spam_report">
                                        <div class=" d-sm-block">
                                            <h2 class="h6 text-gray-400 mb-0"> Spams</h2>
                                            <h3 class="fw-extrabold mb-2">{state.count_spamReport}</h3>
                                        </div>
                                        </a>
                                        <small class="text-gray-500">
                                          {/* Last 3 months */}
                                        </small> 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            
            
           
                    

            </section>
            </div>
            </div>
            
  )
}

export default Index